import registerRootComponent from 'expo/build/launch/registerRootComponent';
// See: https://github.com/necolas/react-native-web/issues/1891#issuecomment-887502705
import 'setimmediate';

import App from './entries/native';

// TS isn't properly inferring entries/app type
// @ts-expect-error
registerRootComponent(App);
